// src/pages/admin/AdminNav.tsx
// admin.readlinker.com 共通のヘッダーナビゲーション。
// 実装済みのページだけをリンクとして表示する（未実装のページへのリンクは置かない）。

import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useAuth } from '../../context/AuthContext';
import { useAppTokens } from '../../context/ThemeModeContext';

const NAV_ITEMS = [
  { to: '/admin', label: 'ダッシュボード' },
  { to: '/admin/hanmoto', label: '版元ドットコム' },
  { to: '/admin/announcement', label: 'お知らせ' },
  { to: '/admin/cache', label: 'キャッシュ' },
  { to: '/admin/users', label: 'ユーザー' },
];

const AdminNav: React.FC = () => {
  const TOKENS = useAppTokens();
  const { user, logout } = useAuth();
  const location = useLocation();

  return (
    <Box
      sx={{
        borderBottom: `1px solid ${TOKENS.border}`,
        background: TOKENS.glassStrong,
        px: 2,
        py: 1.5,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        flexWrap: 'wrap',
        gap: 1,
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
        <Typography sx={{ fontSize: 14, fontWeight: 700, color: TOKENS.text }}>ReadLinker Admin</Typography>
        <Box sx={{ display: 'flex', gap: 1.5 }}>
          {NAV_ITEMS.map((item) => {
            const active = location.pathname === item.to;
            return (
              <Box
                key={item.to}
                component={Link}
                to={item.to}
                sx={{
                  fontSize: 12.5,
                  textDecoration: 'none',
                  color: active ? TOKENS.text : TOKENS.textSub,
                  fontWeight: active ? 700 : 400,
                  borderBottom: active ? `2px solid ${TOKENS.accent}` : '2px solid transparent',
                  pb: 0.25,
                }}
              >
                {item.label}
              </Box>
            );
          })}
        </Box>
      </Box>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
        <Typography sx={{ fontSize: 11.5, color: TOKENS.textSub }}>{user?.username}</Typography>
        <Box
          component="button"
          onClick={logout}
          sx={{
            fontSize: 11.5,
            color: TOKENS.textSub,
            background: 'none',
            border: 'none',
            cursor: 'pointer',
            textDecoration: 'underline',
            p: 0,
          }}
        >
          ログアウト
        </Box>
      </Box>
    </Box>
  );
};

export default AdminNav;
